import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {catchError, map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';

const routes = {
  enterprise: (id: any) => `/enterprises/${id}`,
  update: (id: number) => `/enterprises/update/${id}`,
  search: () => `/enterprises/search/enterprise-tenant`,
  detailCusByEnterprise: () => '/customer/detail-customer-by-enterprise',
  getPermissionManageBranch: (id: string) => `/enterprises/configs/${id}`,
  getDetailConfigNotification: (scopeType: number, enterpriseId: string) => `/notification-enterprise/detail/${enterpriseId}/${scopeType}`,
  updateEnterpriseCongfig: '/enterprises/update-configs',
  updateEnterpriseNotificationCongfig: '/notification-enterprise/create',
  addEnterpriseConfig: '/enterprises/update-configs-enterprise',
  importIpWithFile: '/file/import-file-ip-allowed',
  checkVneid: '/vneid/check-limit-verify-vneid',
  downloadFileResult: '/file/get-result-file-ip-allowed?fileResult=',
  getNational: '/contract-employment/moha/national',
};

@Injectable({
  providedIn: 'root'
})
export class EnterpriseService {

  constructor(
    private apiService: ApiService
  ) {
  }

  getEnterpriseByID(id): Observable<any> {
    return this.apiService.get(routes.enterprise(id)).pipe(
      map(data => {
        return data;
      })
    );
  }

  // Giong getEnterpriseByID nhung khong block UI (X-Silent-Loading)
  getEnterpriseByIDSilently(id): Observable<any> {
    return this.apiService.getSilently(routes.enterprise(id)).pipe(
      map(data => {
        return data;
      })
    );
  }

  updateEnterprise(id: number, value, callBack: any, noCallBack: any, errCallback: any) {
    this.apiService.putAndCheckVersion(
      routes.update(id),
      value,
      callBack,
      noCallBack,
      errCallback
    );
  }

  getDetailCusByEnterprise(contractId: string): Observable<any> {
    return this.apiService.get(`${routes.detailCusByEnterprise()}/` + contractId).pipe(
      map(data => {
        return data;
      })
    );
  }

  filterEnterpriseActionLog(filter: any) {
    return this.apiService.post('/enterprise-action-log/filter', filter)
      .pipe(map(res => {
        return res;
      }));
  }


  searchEnterprise(keyword: string) {
    return this.apiService.post(routes.search(), {keyword}).pipe(
      map(data => {
        return data;
      })
    )
  }

  getPermissionManageBranch(id: string) {
    return this.apiService.get(routes.getPermissionManageBranch(id)).pipe(
      map(res => {
        return res;
      })
    );
  }
  getEnterpriseConfigNotification(scopeType: number, enterpriseId: string) {
    return this.apiService.get(routes.getDetailConfigNotification(scopeType, enterpriseId)).pipe(
      map(res => {
        return res;
      })
    );
  }

  getNationalList() {
    return this.apiService.get(routes.getNational).pipe(
      map(res => {
        return res;
      })
    );
  }

  updateEnterpriseConfig(obj) {
    return this.apiService.post(routes.updateEnterpriseCongfig, obj).pipe(
      map(res => {
        return res;
      })
    );
  }

  updateEnterpriseNotificationConfig(body:any) {
    return this.apiService.post(routes.updateEnterpriseNotificationCongfig, body).pipe(
      map(res => {
        return res;
      })
    );
  }

  addEnterpriseConfig(obj) {
    return this.apiService.post(routes.addEnterpriseConfig, obj).pipe(
      map(res => {
        return res;
      })
    );
  }
  importFromExcel(listFile: any) {
    const formdata = new FormData();
    formdata.append('file', listFile[0]);
    return this.apiService.postUpload2(routes.importIpWithFile, formdata)
      .pipe(map(res => {
        return res;
      }));
  }
  getResultFile(id: string) {
    return this.apiService.getFilePostMethod(`${routes.downloadFileResult}${id}`, null)
        .pipe(map(res => {
            return res;
  }))
}

getCheckVerifyVneid() {
  return this.apiService.get(routes.checkVneid)
    .pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        return of({ success: false, data: 'false', message: err });
      })
    );
}
}
